import { applyMiddleware, compose, createStore } from 'redux';
import { thunk } from 'redux-thunk';
import { persistStore } from 'redux-persist';
import { createBrowserHistory } from 'history';
import { createReduxHistoryContext } from 'redux-first-history';
// import immutableStateInvariantMiddleware from 'redux-immutable-state-invariant';
import rootReducer from '../reducers/rootReducer.js';

const isDevelopment = process.env.NODE_ENV === 'development';
const DEBUG_MODE = false;

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: createBrowserHistory()
});

const composeEnhancers =
  isDevelopment && typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ //
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(DEBUG_MODE ? { trace: true, traceLimit: 25 } : { trace: false })
    : compose;

function configureStore(preloadedState) {
  const middlewares = [routerMiddleware, thunk];

  /**
   * Note uncomment this whenever you need to find state being mutated.
   */
  // const isDevelopment = process.env.NODE_ENV === 'development';
  // if (isDevelopment) {
  //   middlewares.push(immutableStateInvariantMiddleware());
  // }

  return createStore(
    rootReducer(routerReducer), //
    preloadedState,
    composeEnhancers(applyMiddleware(...middlewares))
  );
}

const store = configureStore();
const persistor = persistStore(store);
const history = createReduxHistory(store);

export { store, persistor, history };
